import { compact } from 'lodash';

import { UNIT_CO2_UNKNOWN } from '@/lib/constants';
import { EmissionsModeBreakdown, EmissionStats } from '@/types';

export const getTotalRouteModeEmissions = (stats: (EmissionStats | undefined)[]): EmissionsModeBreakdown => {
  const combinedEmissions = compact(stats);
  return combinedEmissions.reduce(
    (accum, emission) => {
      if (emission.average > 0) {
        const currentMode = emission.mode as keyof EmissionsModeBreakdown;
        return {
          ...accum,
          total: accum.total + emission.average,
          unit: emission.unit,
          [currentMode]: Number(accum[currentMode]) + Number(emission.average),
        };
      }
      return accum;
    },
    {
      total: 0,
      road: 0,
      rail: 0,
      air: 0,
      water: 0,
      unit: UNIT_CO2_UNKNOWN,
    } as EmissionsModeBreakdown,
  );
};
